module.exports = __webpack_public_path__ + "static/flags/BD-6d19bdad4056c389709f152cd1a8bbb8.gif";